export type TechCategory =
  | "Frontend"
  | "Backend"
  | "Devops"
  | "Cloud Platforms"
  | "Design"
  | "Digital Marketing"
  | "Iot";

export type Tech = {
  name: string;
  category: TechCategory;
  slug: string | null;
  color: string;
};

export const TECH_CATEGORIES: ("All" | TechCategory)[] = [
  "All",
  "Frontend",
  "Backend",
  "Devops",
  "Cloud Platforms",
  "Design",
  "Digital Marketing",
  "Iot",
];

export const TECHS: Tech[] = [
  // Frontend
  { name: "CSS",            category: "Frontend", slug: "css3",        color: "1572B6" },
  { name: "HTML",           category: "Frontend", slug: "html5",       color: "E34F26" },
  { name: "JavaScript",     category: "Frontend", slug: "javascript",  color: "F7DF1E" },
  { name: "Gatsby",         category: "Frontend", slug: "gatsby",      color: "663399" },
  { name: "Ionic",          category: "Frontend", slug: "ionic",       color: "3880FF" },
  { name: "Material UI",    category: "Frontend", slug: "mui",         color: "007FFF" },
  { name: "Next.js",        category: "Frontend", slug: "nextdotjs",   color: "FFFFFF" },
  { name: "ReactJS",        category: "Frontend", slug: "react",       color: "61DAFB" },
  { name: "Redux",          category: "Frontend", slug: "redux",       color: "764ABC" },
  { name: "Tailwind CSS",   category: "Frontend", slug: "tailwindcss", color: "06B6D4" },
  { name: "TypeScript",     category: "Frontend", slug: "typescript",  color: "3178C6" },

  // Backend
  { name: "Python Django",  category: "Backend",  slug: "django",      color: "092E20" },
  { name: "Node.js",        category: "Backend",  slug: "nodedotjs",   color: "5FA04E" },
  { name: "Python Flask",   category: "Backend",  slug: "flask",       color: "FFFFFF" },
  { name: "GraphQL",        category: "Backend",  slug: "graphql",     color: "E10098" },
  { name: "TensorFlow",     category: "Backend",  slug: "tensorflow",  color: "FF6F00" },
  { name: "Keras",          category: "Backend",  slug: "keras",       color: "D00000" },

  // Devops
  { name: "CI/CD",          category: "Devops",          slug: "githubactions", color: "2088FF" },
  { name: "Docker",         category: "Devops",          slug: "docker",        color: "2496ED" },
  { name: "Jenkins",        category: "Devops",          slug: "jenkins",       color: "D24939" },
  { name: "Kubernetes",     category: "Devops",          slug: "kubernetes",    color: "326CE5" },

  // Cloud — Simple Icons doesn't ship per-service AWS marks, so the AWS
  { name: "AWS Cognito",        category: "Cloud Platforms", slug: "amazonwebservices", color: "FF9900" },
  { name: "AWS Lambda",         category: "Cloud Platforms", slug: "awslambda",         color: "FF9900" },
  { name: "Digital Ocean",      category: "Cloud Platforms", slug: "digitalocean",      color: "0080FF" },
  { name: "Firebase",           category: "Cloud Platforms", slug: "firebase",          color: "FFCA28" },
  { name: "Google Cloud",       category: "Cloud Platforms", slug: "googlecloud",       color: "4285F4" },
  { name: "AWS Greengrass",     category: "Cloud Platforms", slug: "amazonwebservices", color: "FF9900" },

  // Design — Affinity brands aren't on Simple Icons, so they fall back to
  { name: "Adobe Illustrator",  category: "Design",          slug: "adobeillustrator", color: "FF9A00" },
  { name: "Adobe Photoshop",    category: "Design",          slug: "adobephotoshop",   color: "31A8FF" },
  { name: "Adobe XD",           category: "Design",          slug: "adobexd",          color: "FF61F6" },
  { name: "Figma",              category: "Design",          slug: "figma",            color: "F24E1E" },
  { name: "Affinity Designer",  category: "Design",          slug: null,               color: "1B72BE" },
  { name: "Affinity Photo",     category: "Design",          slug: null,               color: "7E4DD2" },

  // Digital marketing
  { name: "Facebook Ads",       category: "Digital Marketing", slug: "meta",            color: "0467DF" },
  { name: "Facebook Pixel",     category: "Digital Marketing", slug: "facebook",        color: "0866FF" },
  { name: "Google Analytics",   category: "Digital Marketing", slug: "googleanalytics", color: "E37400" },
  { name: "Yoast",              category: "Digital Marketing", slug: "yoast",           color: "A4286A" },

  // Blynk and Particle aren't on Simple Icons, so they use the fallback tile.
  { name: "Eclipse IoT",        category: "Iot", slug: "eclipseide",  color: "2C2255" },
  { name: "Cisco IoT",          category: "Iot", slug: "cisco",       color: "1BA0D7" },
  { name: "Qt",                 category: "Iot", slug: "qt",          color: "41CD52" },
  { name: "Blynk",              category: "Iot", slug: null,          color: "00C6B5" },
  { name: "Particle",           category: "Iot", slug: null,          color: "00ADEF" },
];

/** URL helper for the Simple Icons CDN. */
export function techIconUrl(t: Tech): string | null {
  if (!t.slug) return null;
  return `https://cdn.simpleicons.org/${t.slug}/${t.color}`;
}
